import { Image, Label, Tag, Text } from 'react-konva';
import useImage from 'use-image';
import regionalIndicatorUnicode from "../referenceData/RegionalIndicatorUnicode.json";
import config from "../etc/config.json";
import axios from 'axios';
import moment from 'moment-timezone';
import { isCustomTourJersey } from '../race/C4FLeaderJerseys';

export function fetchJSONFile(path, callback) {
  axios.get(path).then(result => {
    callback(result.data);
  });
}

export function readLocalFile(file, callback) {
  let reader = new FileReader();
  reader.onload = callback;
  reader.readAsText(file, "UTF-8");
}

var counters = [];

export function addCounter(name) {
  counters[name] = 0;
}

export function getNextCounterValue(name) {
  return ++counters[name];
}

export function isNumber(value) {
  if (typeof value === 'undefined' || value === null || isNaN(value)) return false;
  else return true;
}

export function formatUnixDate(unixDate) {
  let date = new Date(parseInt(unixDate) * 1000);
  return date.toLocaleTimeString();
}

export function getTimeSinceServertime(serverTimeString) {
  let serverTimezoneOffset = moment(serverTimeString).tz('Europe/Berlin').utcOffset()
  let serverTime = moment.utc(serverTimeString).subtract(serverTimezoneOffset, 'minutes');
  let serverTimeMillis = serverTime.valueOf();
  return Math.abs((serverTimeMillis - moment().valueOf()) / 1000);
}

export function getTimeDifference(startDate, endDate) {
  return Math.abs((endDate.valueOf() - startDate.valueOf()) / 1000);
}

export const currentISODate = (new Date()).toISOString().split('T')[0];
export const currentYear = (new Date()).getFullYear();
export const getISODate = (date) => date.toISOString().split('T')[0];
export const addDays = (date, days) => new Date().setDate(date.getDate() + days)

export function getDateList(startingDate, days) {
  let dateList = [];
  let dateObject = new Date(startingDate);
  for(let i = 0; i < days; i++) {
    dateList.push(getISODate(dateObject));
    dateObject.setDate(dateObject.getDate() + 1);
  }
  return dateList;
}

export function addHours(date, hours) {
  date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  return date;
}

export function formatTimeSeconds(seconds) {
  seconds = Number(seconds);
  var h = Math.floor(seconds / 3600);
  var m = Math.floor(seconds % 3600 / 60);
  var s = Math.floor(seconds % 3600 % 60);
  return ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
}

export function formatTimeShort(time) {
  var h = parseInt(time.substr(0, 2))
  var min = parseInt(time.substr(3, 2))
  var min_long = time.substr(3, 2)
  var s = parseInt(time.substr(6, 2))
  var s_long = time.substr(6, 2)
  if (h > 0) {
    return h + "h" + min_long + "'" + s_long + "''";
  }
  else if (min > 0) {
    return min + "'" + s_long + "''";
  }
  else if (s > 0) {
    return min + "'" + s_long + "''";
  }
  else {
    return "0'00''";
  }
}

export function formatTimeLong(time) {
  var h = parseInt(time.substr(0, 2))
  var min_long = time.substr(3, 2)
  var s_long = time.substr(6, 2)
  return h + "h" + min_long + "'" + s_long + "''";
}

export function formatLocalDateTime(date) {
  return moment(date).local().format('DD.MM.YY HH:mm');
}

export function formatCurrency(value, currency = 'USD') {
  return value === 0 || value ?
    value.toLocaleString("en-EN", { style: "currency", currency: currency, maximumFractionDigits: 0, minimumFractionDigits: 0 }) :
    'n/a';
}

export function getCountryCodeForC4FCode(countries, c4fCode) {
  if (countries.some(c => c.c4fCode === c4fCode))
    return countries.find(c => c.c4fCode === c4fCode).countryCode;
  else
    return '';
}

export function getC4FCodeForCountryCode(countries, countryCode) {
  if (countries.some(c => c.countryCode === countryCode))
    return countries.find(c => c.countryCode === countryCode).c4fCode;
  else
    return '';
}

export function getUnicodeFlag(countryCode) {
  if (typeof countryCode !== 'string' || countryCode === null || !countryCode.match(/^[A-Z]{2}$/i))
    return '\uD83C\uDDFA\uD83C\uDDF3';
  else
    return regionalIndicatorUnicode.find(riu => riu.letter === Array.from(countryCode)[0]).unicode +
      regionalIndicatorUnicode.find(riu => riu.letter === Array.from(countryCode)[1]).unicode
}

export function getUnicodeFlagForC4FCode(countries, c4fCode) {
  if (typeof c4fCode !== 'string' || c4fCode === null || !c4fCode.match(/^[A-Z]+$/i))
    return '\uD83C\uDDFA\uD83C\uDDF3';
  else
    return getUnicodeFlag(getCountryCodeForC4FCode(countries, c4fCode));
}

export function getUnicodeFlagForLanguage(countries, language) {
  if (typeof language !== 'string' || language === null || !language.match(/^[A-Z]+$/i))
    return '\uD83C\uDDFA\uD83C\uDDF3';
  else
    return getUnicodeFlag(countries.find(c => c.language === language).countryCode);
}

export function getCountryName(countries, countryCode) {
  if (typeof countryCode === 'undefined' || countryCode === null || !countryCode.match(/[A-Z]{2}/i) || !countries.some(c => c.countryCode === countryCode))
    return 'None';
  else
    return countries.find(c => c.countryCode === countryCode).country;
}

export function getImageFlagForC4FCode(c4fCode) {
  if (typeof c4fCode !== 'string' || c4fCode === null || !c4fCode.match(/^[A-Z]+$/i))
    return null;
  else
    return <img alt={c4fCode} src={config.DIR_FLAGS + c4fCode + ".gif"} height="12" width="18" />;
}

export function getImageFlag(countries, countryCode) {
  if (typeof countryCode !== 'string' || countryCode === null || !countryCode.match(/^[A-Z]{2}$/i))
    return null;
  else
    return getImageFlagForC4FCode(getC4FCodeForCountryCode(countries, countryCode));
}

export function getImageFlagForLanguage(countries, language) {
  if (typeof language !== 'string' || language === null || !language.match(/^[A-Z]+$/i))
    return '\uD83C\uDDFA\uD83C\uDDF3';
  else
    return getImageFlag(countries, countries.find(c => c.language === language).countryCode);
}

// export function getFlag(countryCode) {
//   if (typeof countryCode !== 'string' || countryCode === null || !countryCode.match(/^[A-Z]{2}$/i))
//     return null;
//   else
//     return getImageFlagForC4FCode(getC4FCodeForCountryCode(countryCode));
// }

export function getUnicodeOrImageFlag(countries, countryCode, browserInfo) {
  if (browserInfo && browserInfo.browserSupportsUnicodeFlags)
    return getUnicodeFlag(countryCode);
  else
    return getImageFlag(countries, countryCode);
}

export function getUnicodeOrImageFlagForC4FCode(countries, c4fCode, browserInfo) {
  if (browserInfo && browserInfo.browserSupportsUnicodeFlags)
    return getUnicodeFlagForC4FCode(countries, c4fCode);
  else
    return getImageFlagForC4FCode(c4fCode);
}

export function getUnicodeOrImageFlagForLanguage(countries, language, browserInfo) {
  let countryCode = countries.some(c => c.language === language) ?   
    countries.find(c => c.language === language).countryCode : 'UN';
  
  if (browserInfo && browserInfo.browserSupportsUnicodeFlags)
    return getUnicodeFlag(countryCode);
  else
    return getImageFlag(countries, countryCode);
}

export const RiderImage = props => {
  const [image] = useImage(props.url);
  return <>
    {(props.riderTeamId === props.userTeamId) ?
      <Image
        image={image} x={props.x} y={props.y}
        width={props.width} height={props.height}
      />
      :
      <Image
        image={image} x={props.x} y={props.y}
        width={props.width} height={props.height}
      />
    }
    <Label x={props.x} y={props.y + 20}>
      <Tag fill="white" />
      <Text text={props.riderSprint} fontSize={10} />
    </Label>
    <Label x={props.x} y={props.y + 40}>
      <Tag fill="white" />
      <Text text={props.riderName} fontSize={10} />
    </Label>
  </>;
};

export function getRaceEditionRules(commonRaceRules, raceRulesets, raceEventRules, raceEdition) {
  let numberOfStages = raceEdition.race.numberOfStages;
  let numberOfTeamsFactor = getFactorValue(commonRaceRules, 'NumberOfTeamsFactor', raceEdition.numberOfParticipants, 1);
  let groupNumberFactor = getFactorValue(commonRaceRules, 'GroupNumberFactor', raceEdition.group);
  let c4fPointsCategoryFactorOneDayRace = 1;
  let c4fPointsCategoryFactorStage = 1;
  let c4fPointsCategoryFactorStageRace = 1;
  let prizeMoneyCategoryFactorOneDayRace = 1;
  let prizeMoneyCategoryFactorStage = 1;
  let prizeMoneyCategoryFactorStageRace = 1;
  if (numberOfStages === 1) {
    c4fPointsCategoryFactorOneDayRace = getFactorValue(commonRaceRules, 'OneDayRaceRewardFactorC4FPoints', raceEdition.race.category);
    prizeMoneyCategoryFactorOneDayRace = getFactorValue(commonRaceRules, 'OneDayRaceRewardFactorPrizeMoney', raceEdition.race.category);
  }
  else {
    c4fPointsCategoryFactorStage = getFactorValue(commonRaceRules, 'StageRewardFactorC4FPoints', raceEdition.race.category);
    c4fPointsCategoryFactorStageRace = getFactorValue(commonRaceRules, 'StageRaceRewardFactorC4FPoints', raceEdition.race.category);
    prizeMoneyCategoryFactorStage = getFactorValue(commonRaceRules, 'StageRewardFactorPrizeMoney', raceEdition.race.category);
    prizeMoneyCategoryFactorStageRace = getFactorValue(commonRaceRules, 'StageRaceRewardFactorPrizeMoney', raceEdition.race.category);
  }

  let ruleset = getRuleset(raceRulesets, raceEdition.race.rulesetName);
  return {
    ruleset: ruleset.rules.map(rule => ({ ...rule, ruleDetails: getRuleDefinition(raceRulesets, raceEventRules, raceEdition.race.rulesetName, rule.type, rule.name) })),
    numberOfStages: numberOfStages,
    numberOfTeamsFactor: numberOfTeamsFactor,
    groupNumberFactor: groupNumberFactor,
    c4fPointsCategoryFactorOneDayRace: c4fPointsCategoryFactorOneDayRace,
    c4fPointsCategoryFactorStage: c4fPointsCategoryFactorStage,
    c4fPointsCategoryFactorStageRace: c4fPointsCategoryFactorStageRace,
    prizeMoneyCategoryFactorOneDayRace: prizeMoneyCategoryFactorOneDayRace,
    prizeMoneyCategoryFactorStage: prizeMoneyCategoryFactorStage,
    prizeMoneyCategoryFactorStageRace: prizeMoneyCategoryFactorStageRace,
  }
}

export function getRaceEditionPrizeList(raceEdition, raceEvents, raceEditionRules) {
  let enrichedRaceEvents = [];

  raceEvents.forEach(re => {
    let isTeamReward = re.raceEventName === 'TeamTimeTrial' || re.raceEventName === 'TeamClassification';
    let teams = new Set();
    let teamSizes = [];
    if (isTeamReward) {
      re.raceEventDetails.forEach(red => teams.add(red.teamId));
      Array.from(teams).forEach(team => teamSizes[team] = re.raceEventDetails.filter(red => red.teamId === team).length);
    }

    re.raceEventDetails.forEach(red => {
      let rule = raceEditionRules.ruleset.find(r => r.type === re.raceEventType && r.name === re.raceEventName);
      let ruleDetails = rule.ruleDetails;
      let teamSharingFactor = isTeamReward ? 1 / teamSizes[red.teamId] : 1;
      enrichedRaceEvents.push({
        id: re.id,
        raceEventType: re.raceEventType,
        raceEventName: re.raceEventName,
        ruleName: rule.name,
        sector: re.sector,
        riderName: red.riderName,
        teamName: red.teamName,
        position: red.position,
        stageNumber: re.stageNumber,
        bonusSeconds: ruleDetails.bonusSeconds && ruleDetails.bonusSeconds.length >= red.position ? ruleDetails.bonusSeconds[red.position - 1] : 0,
        prizeMoney: ruleDetails.prizeMoney && ruleDetails.prizeMoney.length >= red.position ? ruleDetails.prizeMoney[red.position - 1] * teamSharingFactor : 0,
        prizeMoneyBase: ruleDetails.prizeMoneyBase && ruleDetails.prizeMoneyBase.length >= red.position ? ruleDetails.prizeMoneyBase[red.position - 1] * teamSharingFactor : 0,
        prizeMoneyPerStage: ruleDetails.prizeMoneyPerStage && ruleDetails.prizeMoneyPerStage.length >= red.position ? ruleDetails.prizeMoneyPerStage[red.position - 1] * teamSharingFactor : 0,
        c4fPoints: ruleDetails.c4fPoints && ruleDetails.c4fPoints.length >= red.position ? ruleDetails.c4fPoints[red.position - 1] * teamSharingFactor : 0,
        c4fPointsBase: ruleDetails.c4fPointsBase && ruleDetails.c4fPointsBase.length >= red.position ? ruleDetails.c4fPointsBase[red.position - 1] * teamSharingFactor : 0,
        c4fPointsPerStage: ruleDetails.c4fPointsPerStage && ruleDetails.c4fPointsPerStage.length >= red.position ? ruleDetails.c4fPointsPerStage[red.position - 1] * teamSharingFactor : 0,
        mountainPoints: ruleDetails.mountainPoints && ruleDetails.mountainPoints.length >= red.position ? ruleDetails.mountainPoints[red.position - 1] : 0,
        sprintPoints: ruleDetails.sprintPoints && ruleDetails.sprintPoints.length >= red.position ? ruleDetails.sprintPoints[red.position - 1] : 0
      })
    })
  });

  // calculate totals
  enrichedRaceEvents = enrichedRaceEvents.map(re => {
    let pointsFactor = 1;
    if (re.raceEventType === 'StageRaceReward') pointsFactor = raceEditionRules.c4fPointsCategoryFactorStageRace;
    else if (raceEditionRules.numberOfStages > 1) pointsFactor = raceEditionRules.c4fPointsCategoryFactorStage;
    else pointsFactor = raceEditionRules.c4fPointsCategoryFactorOneDayRace;

    let prizeMoneyFactor = 1;
    if (re.raceEventType === 'StageRaceReward') prizeMoneyFactor = raceEditionRules.prizeMoneyCategoryFactorStageRace;
    else if (raceEditionRules.numberOfStages > 1) prizeMoneyFactor = raceEditionRules.prizeMoneyCategoryFactorStage;
    else prizeMoneyFactor = raceEditionRules.prizeMoneyCategoryFactorOneDayRace;

    return {
      ...re,
      prizeMoneyTotal: (re.prizeMoney + re.prizeMoneyBase + re.prizeMoneyPerStage * raceEdition.race.numberOfStages) * prizeMoneyFactor,
      c4fPointsTotal: (re.c4fPoints + re.c4fPointsBase) * pointsFactor + re.c4fPointsPerStage * raceEdition.race.numberOfStages
    }
  });

  // apply factors for category, teams, group, etc.
  enrichedRaceEvents = enrichedRaceEvents.map(re => ({
    ...re,
    prizeMoneyAdapted: re.prizeMoneyTotal * raceEditionRules.numberOfTeamsFactor,
    c4fPointsAdapted: re.c4fPointsTotal * raceEditionRules.numberOfTeamsFactor * raceEditionRules.groupNumberFactor
  })
  );

  return enrichedRaceEvents;
}

export function getAllPrizesForRuleset(raceRulesets, rulesetName) {
  if (!raceRulesets.some(rr => rr.name === rulesetName)) throw new Error('Unknown raceRuleset ' + rulesetName);
  return raceRulesets.find(rr => rr.name === rulesetName);
}

export function getRuleset(raceRulesets, rulesetName) {
  if (!raceRulesets.some(rr => rr.name === rulesetName)) throw new Error('Unknown raceRuleset ' + rulesetName);
  return raceRulesets.find(rr => rr.name === rulesetName);
}

// export function getAllRulesets() {
//   return raceRulesets;
// }

export function getRuleTypeDescription(ruleTypes, ruleType) {
  if (!ruleTypes.some(rt => rt.name === ruleType)) throw new Error('Unknown ruleType ' + ruleType);
  return ruleTypes.find(rt => rt.name === ruleType);
}

export function getRuleTypesForRuleset(raceRulesets, rulesetName) {
  let ruleTypes = new Set();
  getRuleset(raceRulesets, rulesetName).rules.map(rule => ruleTypes.add(rule.type));
  return Array.from(ruleTypes);
}

export function getRuleNamesForRulesetAndType(raceRulesets, rulesetName, ruleType) {
  return getRuleset(raceRulesets, rulesetName).rules.filter(rule => rule.type === ruleType).map(rule => rule.name);
}

export function getRuleDefinition(raceRulesets, raceEventRules, rulesetName, type, name) {
  // look for ruleset first
  let ruleset = getRuleset(raceRulesets, rulesetName);

  // then look for rule name for the provided type
  if (!ruleset.rules.some(rule => rule.type === type && rule.name === name)) throw new Error('No rule name found for type ' + type + ' and ' + name);
  let ruleName = ruleset.rules.find(rule => rule.type === type && rule.name === name).rule;

  // then check for the actual rule and return it
  if (!raceEventRules.some(rer => rer.type === type && rer.name === ruleName)) throw new Error('No rule definition found for name ' + ruleName);
  let rule = raceEventRules.find(rer => rer.type === type && rer.name === ruleName);
  return rule;
}

export function getRecurringEvent(recurringEvents, recurringEventId) {
  if (!recurringEvents.some(re => re.id === recurringEventId)) throw new Error('Unknown recurringEvent ' + recurringEventId);
  return recurringEvents.find(re => re.id === recurringEventId);
}

export function getRecurringEventByRulesetName(recurringEvents, rulesetName) {
  if (recurringEvents.some(re => re.rulesetName === rulesetName))
    return recurringEvents.find(re => re.rulesetName === rulesetName);
  else
    return null;
}

export function getFactorValue(commonRaceRules, name, value, defaultValue = null) {
  if (!commonRaceRules.some(rr => rr.name === name)) throw new Error('Unknown race rule ' + name);
  let rule = commonRaceRules.find(rr => rr.name === name);
  if (!rule.factors.some(m => m.value === Number(value))) {
    if (defaultValue !== null)
      return defaultValue;
    else
      throw new Error('Unknown factor value ' + value);
  }
  return rule.factors.find(m => m.value === Number(value)).factor;
}

export function validateUserName(userName) {
  // maximum length
  if (userName.length > 25)
    return { result: false, message: 'Maximum length for user name is 25 characters, "' + userName + '" has ' + userName.length };

  // minimum length
  if (userName.length < 3)
    return { result: false, message: 'Minimum length for user name is 3 characters, "' + userName + '" has ' + userName.length };

  // start with letter or number
  if (!userName.match(/^[a-zà-ÿ0-9]+/i))
    return { result: false, message: 'User name needs to start with a letter or number' };

  // end with letter or number
  if (!userName.match(/[a-zà-ÿ0-9]+$/i))
    return { result: false, message: 'User name needs to end with a letter or number' };

  // at least one non-number
  if (!userName.match(/[a-zà-ÿ -]+/i))
    return { result: false, message: 'User name needs to contain at least one letter' };

  // letters, numbers, whitespace, dash
  if (!userName.match(/^[a-zà-ÿ0-9 -]+$/i))
    return { result: false, message: 'User name may only contain numbers, letters, whitespaces and hyphens' };

  return { result: true }
}

export function getRandomIntFromInterval(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function popRandomElement(array) {
  const randomIndex = Math.floor(Math.random() * array.length);
  return popNthElement(randomIndex);
}

export function popNthElement(array, index) {
  const value = array[index];
  array.splice(index, 1);
  return value;
}

export function getNextElementOfArray(array, value) {
  // find value
  let valueIndex = array.indexOf(value);
  // get next, if not last
  return valueIndex === array.length - 1 ? array[array.length - 1] : array[valueIndex + 1];
}

export function getPreviousElementOfArray(array, value) {
  // find value
  let valueIndex = array.indexOf(value);
  // get previous, if not first
  return valueIndex === 0 ? array[0] : array[valueIndex - 1];
}

export const isNationalTeamRace = (eventType) => ['WorldChampionships', 'Olympics', 'EuropeanChampionships'].includes(eventType);

export function getJerseyForRacer(countries, racer, team, race) {
  let jerseyFile = null;
  if (!['None', 'RedLantern', 'MostActive'].includes(racer.raceJersey)) {
      let raceName = race.recurringEvent ? race.recurringEvent : race.raceName;
      jerseyFile = config.SUBDIR_LEADERJERSEYS + (isCustomTourJersey(raceName) ? raceName + '_' : '') + racer.jerseyFile;
  }
  else if (racer.rider.jerseys && racer.rider.jerseys.length > 0) {
    if (racer.rider.jerseys.includes('C4FLeader'))
      jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'wr1.png';
    else if (racer.rider.jerseys.includes('WCRoad'))
      jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'wc.png';
    else if (racer.rider.jerseys.includes('WCITT'))
      jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'wcitt.png';
    else if (racer.rider.jerseys.length > 0 && racer.rider.jerseys[0].substring(0, 3) === 'NC_')
      jerseyFile = config.SUBDIR_NATIONALJERSEYS + 'trikot_' + getC4FCodeForCountryCode(countries, racer.rider.jerseys[0].substring(3)) + '.png';
    else if (racer.rider.jerseys.includes('ECRoad'))
      jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'ec.png';
    else if (racer.rider.jerseys.includes('ECRoad'))
      jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'ecitt.png';
    else if (racer.rider.jerseys.includes('OCRoad'))
      jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'oc.png';
    else if (racer.rider.jerseys.includes('OCRoad'))
      jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'ocitt.png';
  }
  else if (isNationalTeamRace(race.eventType))
    jerseyFile = config.SUBDIR_NATIONALJERSEYS + 'trikot_' + getC4FCodeForCountryCode(countries, racer.rider.nationality) + '.png';
  else if (team.jerseyFile !== 'standard.png')
    jerseyFile = config.SUBDIR_USERJERSEYS + team.jerseyFile;
  else 
    jerseyFile = config.SUBDIR_SPECIALJERSEYS + 'standard.png';
  return jerseyFile;
}

    /**
    * returns an array with moving average of the input array
    * @param array - the input array
    * @param count - the number of elements to include in the moving average calculation
    */
    export function movingAverage(array, count, qualifier){
      // calculate average for subarray
      var avg = function(array, qualifier){

          var sum = 0, count = 0, value;
          for (var i in array){
              value = array[i];
              if (!qualifier || qualifier(value)){
                  sum += value;
                  count++;
              }
          }

          return sum / count;
      };

      var result = [], val;

      // pad beginning of result with null values
      for (var i=0; i < count-1; i++)
          result.push(null);

      // calculate average for each subarray and add to result
      for (var i=0, len=array.length - count; i <= len; i++){

          val = avg(array.slice(i, i + count), qualifier);
          if (isNaN(val))
              result.push(null);
          else
              result.push(val);
      }
      return result;
  }

  export const getRegularTeam = (userInformation) => 
      userInformation && userInformation.teams && userInformation.teams.some(t => t.type === 'Regular') ? 
        userInformation.teams.find(t => t.type === 'Regular') : null;

  export const hasNationalTeam = (userInformation) => 
    userInformation && userInformation.teams && userInformation.teams.some(t => t.type === 'NationalTeam');

  export const getNationalTeam = (userInformation) => 
    hasNationalTeam(userInformation) ? 
      userInformation.teams.find(t => t.type === 'NationalTeam') : null;
            
  export const average = arr => sum(arr) / arr.length;
  export const sum = arr => arr.reduce((p, c) => p + c, 0);
  export function min (arr, def = 0) {
    return arr && arr.length ? Math.min( ...arr ) : def;
  }
  export function max (arr, def = 0) {
    return arr && arr.length ? Math.max( ...arr ) : def;
  }

  export function isReadyForSelection(events) {
    return events && events.some(e => isNationalTeamRace(e.eventType) && e.nationalTeamSelectionInterval);
  }

  export function getNationalTeamSelectionTime(events, user) {
    if (user && events && events.some(e => isNationalTeamRace(e.eventType) && e.nationalTeamSelectionInterval)) {
      let event = events.find(e => isNationalTeamRace(e.eventType) && e.nationalTeamSelectionInterval);
      // get start time
      let startTime = new Date(event.nationalTeamSelectionStart);
      // get interval
      let selectionInterval = parseInt(event.nationalTeamSelectionInterval);
      // get rank
      let selectionRank = parseInt(user.nationalTeamSelectionRank);
      // calculate selection date
      return addHours(startTime, (selectionRank - 1) * selectionInterval);
    }
    return false;
  }

  const resultEmojis = {
    OK: '✅',
    NOK: '❌'
  }

  export const resultEmoji = (result) => result in resultEmojis ? resultEmojis[result] : '';

  export const isAdmin = (userInformation) => userInformation !== null && userInformation.roles.includes('Admin');
  export const isDeveloper = (userInformation) => userInformation !== null && userInformation.roles.includes('Developer');
  export const isDevelopmentSupport = (userInformation) => userInformation !== null && userInformation.roles.includes('DevelopmentSupport');

  export const truncateString = (string, length) => string.length > length ? string.substr(0, length - 3) + '...' : string;

  export const roundDigits = (number, digits) => Math.round(number * Math.pow(10, digits)) / Math.pow(10, digits);

  export function gaussianRandom(mean = 0, stdev = 1) {
    const u = 1 - Math.random(); // Converting [0,1) to (0,1]
    const v = Math.random();
    const z = Math.sqrt( -2.0 * Math.log( u ) ) * Math.cos( 2.0 * Math.PI * v );
    // Transform to the desired mean and standard deviation:
    return z * stdev + mean;
  }

  export const printJSONObject = (object) => object ? <pre>{JSON.stringify(object, null, 2)}</pre> : '';


  export function randomString(characters, length) {
    let result = '';
    for (let counter = 0; counter < length; counter++)
      result += characters.charAt(Math.floor(mathRandomCrypto() * characters.length));
    return result;
  }
  
  export const randomStringLettersAndNumbers = (length) => randomString('abcdefghijklmnopqrstuvwxyz0123456789', length);
  export const randomStringOnlyLetters = (length) => randomString('abcdefghijklmnopqrstuvwxyz', length);
  export const randomStringOnlyNumbers = (length) => randomString('0123456789', length);
  export const cryptoRandom = () => crypto.getRandomValues(new Uint32Array(1))[0];
  export const mathRandomCrypto = () => cryptoRandom() * Math.pow(2, -32);
  export const randomNumber = (min, max) => Math.floor(mathRandomCrypto() * (max - min + 1)) + min;
  export const randomNumberString = (min, max) => randomNumber(min, max).toString();
  export const getRandomArrayElement = (array) => Array.isArray(array) && array.length > 0 ? array[randomNumber(0, array.length - 1)] : null; 
  
export const mathJaxConfig = {
  tex: {
    inlineMath: [["\\(", "\\)"]],
    displayMath: [["\\[", "\\]"]],
  },
};

export const isEmptyString = string => !string || string === ''; 

export const isInteger = (value) => !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));

